export default __webpack_public_path__ + "static/media/WinterSale_CampingCoolers_900x525.e9e85b33.jpg";